<header class="container-fluid">
    <div class="texto-environment" *ngIf="environmentPrefix != 'prod'">
        <div translate>header.{{environmentPrefix}}</div>
    </div>
    <div class="row ">
        <div class="col-12 barraAuxiliar zonaCliente">

            <div ngbDropdown class="dropdown show col login">

                <span class="active banderaZona" translate>{{swClientActive ? 'header.clientZone' : 'header.esfZone'}}</span>

                <a class="dropdown-toggle tipo_element_to_target" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle><span class="truncate">{{ person.tradeName }}</span></a>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuLink" ngbDropdownMenu>

                    <a class="dropdown-item" routerLinkActive="active" routerLink="/cliente" translate>header.userClient</a>
                    <a class="dropdown-item" routerLinkActive="active" routerLink="/empresas" translate>header.userESF</a>
                </div>

            </div>


            <!-- Pendiente de implementar Mensajes Pendientes

            <div class="col-3 col-md-2 col-lg-1 mensajes">
                <a href="#" title="Mensajes pendientes"><i class="fa fa-envelope"></i> <span>13</span></a>
            </div>

            FIN Pendiente de implementar Mensajes Pendientes-->

            <!-- Comentado hasta que esté las traducciones
            <div class="dropdown show">
                <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLinkLanguage" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Español</a>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuLinkLanguage">
                    <a class="dropdown-item" href="#" translate>header.lenguageSpanish</a>
                    <a class="dropdown-item" href="#" translate>header.LenguageEnglish</a>
                </div>
            </div>
            -->
            <div class="logOut">
                <a (click)="logout()" title="Logout"> <i class="fa fa-sign-out"></i></a>
            </div>

        </div>
    </div>
    <div class="row logos">
        <div class="logoInstituicional"><img src="assets/images/logoInstitucional.png" alt="Logo institucional"></div>
        <div class="col"></div>
        <div class="logoB2B"><a [routerLink]="['/portal']"><img src="assets/images/logoB2B.png" alt="Logo FACeB2B"></a></div>

    </div>
</header>



// WEBPACK FOOTER //
// ./src/app/app-manager/mng-header/mng-header.component.html